import axios from "@/lib/axios";

export default class BaseProductLinkageService {
  constructor(path) {
    this.path = path;
  }

  // Product listing operations
  async getLinkedProducts(id, filters) {
    const { data } = await axios.get(`${this.path}/${id}/linked-products`, {
      params: filters,
    });
    return {
      data: data.content,
      filter: {
        ...filters,
        totalPages: data.totalPages,
        page: data.page,
        totalElements: data.totalElements,
      },
    };
  }

  async getUnlinkedProducts(id, filters) {
    const { data } = await axios.get(`${this.path}/${id}/unlinked-products`, {
      params: filters,
    });
    return {
      data: data.content,
      filter: {
        ...filters,
        page: data.page,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
      },
    };
  }

  // Single product operations
  async linkProducts(id, { merchantProductIds }) {
    return axios.put(`${this.path}/${id}/link-products`, {
      merchantProductIds,
    });
  }

  async unlinkProducts(id, { merchantProductIds }) {
    return axios.put(`${this.path}/${id}/unlink-products`, {
      merchantProductIds,
    });
  }

  // Bulk operations with filters
  async linkAllProducts(id, filter) {
    // Remove pagination params from filter for bulk operations
    const { page, size, totalPages, totalElements, ...filterParams } = filter;
    return axios.put(`${this.path}/${id}/link-products-filter`, {
      ...filterParams,
    });
  }

  async unlinkAllProducts(id, filter) {
    // Remove pagination params from filter for bulk operations
    const { page, size, totalPages, totalElements, ...filterParams } = filter;
    return axios.put(`${this.path}/${id}/unlink-products-filter`, {
      ...filterParams,
    });
  }
}
